import Signal from '@signals/Signal.js';

export const COLUMN_EVENT_TYPES = {
  VISIBILITY_CHANGED: 'visibility_changed', // Column visibility was toggled
  TITLE_CHANGED: 'title_changed', // Column title was changed
  WIDTH_CHANGED: 'width_changed', // Column width was changed
  WIDTH_CHANGING: 'width_changing', // Real-time width change during resize
  SORTED: 'sorted', // Column sorting changed
  DELETED: 'deleted', // Column was deleted
  ADDED: 'added', // Column was added
  OPTIONS_UPDATED: 'options_updated', // Select column options were modified
  RESET: 'reset', // Reset all columns to default state (width, visibility, sorted by createdAt)
  ORDERING: 'ordering', // Order columns
};

export const columnUpdate = new Signal();

export const projectListReOrder = new Signal();
